import { Route } from 'react-router-dom';
import React from 'react';
import { ApmRoutes } from '@elastic/apm-rum-react';
import Shell from './shell/Shell';
import { MyTripsPage } from './pages/tripCollections/MyTripsPage';
import { FavoritesPage } from './pages/tripCollections/FavoritesPage';
import { EditTripPage } from './pages/editTrip/EditTripPage';
import { SilentRefresh } from './components/silentRefresh';
import { ProfilePage } from './pages/profile/ProfilePage';
import { AccountPage } from './pages/account/AccountPage';
import { LoginPage } from './pages/login/LoginPage';
import { SignOutPage } from './pages/signout';
import NotFoundPage from './pages/notFound/NotFoundPage';
import { TripPage } from './pages/trip/TripPage';
import NotificationsPage from './pages/notifications/NotificationsPage';
import { useTrackPageView } from './hooks/trip/useTrackPageView';
import { useScrollToTop } from './hooks/useScrollToTop';
import { ErrorBoundary } from './components/errorBoundary';
import { ProtectedRoute } from './components/ProtectedRoute';

const App = () => {
  useTrackPageView();
  useScrollToTop();

  return (
    <>
      <SilentRefresh />
      <Shell>
        <ApmRoutes>
          <Route
            path="/"
            element={
              <ErrorBoundary>
                <LoginPage />
              </ErrorBoundary>
            }
          />
          <Route
            path="/home"
            element={
              <ErrorBoundary>
                <ProtectedRoute>
                  <MyTripsPage />
                </ProtectedRoute>
              </ErrorBoundary>
            }
          />
          <Route
            path="/favorites"
            element={
              <ErrorBoundary>
                <ProtectedRoute>
                  <FavoritesPage />
                </ProtectedRoute>
              </ErrorBoundary>
            }
          />
          <Route
            path="/trips/:tripId"
            element={
              <ErrorBoundary>
                <ProtectedRoute>
                  <EditTripPage />
                </ProtectedRoute>
              </ErrorBoundary>
            }
          />
          <Route
            path="/account"
            element={
              <ErrorBoundary>
                <ProtectedRoute>
                  <AccountPage />
                </ProtectedRoute>
              </ErrorBoundary>
            }
          />
          <Route
            path="/notifications"
            element={
              <ErrorBoundary>
                <ProtectedRoute>
                  <NotificationsPage />
                </ProtectedRoute>
              </ErrorBoundary>
            }
          />
          <Route
            path="/trip/*"
            element={
              <ErrorBoundary>
                <TripPage />
              </ErrorBoundary>
            }
          />
          <Route
            path="/p/trip/*"
            element={
              <ErrorBoundary>
                <TripPage />
              </ErrorBoundary>
            }
          />
          <Route
            path="/profile/:userId"
            element={
              <ErrorBoundary>
                <ProfilePage />
              </ErrorBoundary>
            }
          />
          <Route
            path="/signout"
            element={
              <ErrorBoundary>
                <SignOutPage />
              </ErrorBoundary>
            }
          />
          <Route
            path="/*"
            element={
              <ErrorBoundary>
                <NotFoundPage />
              </ErrorBoundary>
            }
          />
        </ApmRoutes>
      </Shell>
    </>
  );
};

export default App;
